import axios from 'axios'
import moment from 'moment'

import { store } from '../stores'
import { setAutomaticUpdate, setVersionInfo } from '../actions/appState'
import { networkConnected } from './networkConnected'

const INTERVAL_TIMER = 900000
const AUTOMATIC_UPDATE_TIMER = 1800000

const getRemoveVersion = (data) => {
  const versionRegex = /v(0|([1-9]\d*))\.(0|([1-9]\d*))\.(0|([1-9]\d*))(-([0-9a-zA-Z-]+(\.[0-9A-Za-z-]+)*))?(\+([0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*))?/
  const version = data?.match?.(versionRegex)
  return version[0]
}

const versionDidChange = (remoteVersion) => {
  return [remoteVersion !== process.env.REACT_APP_VERSION, remoteVersion]
}

export const refreshCache = () => {
  networkConnected().then(() => {
    store.dispatch(setVersionInfo({ updateAvailable: false, automaticallyUpdate: false }))
    window.location = `${window.location.origin}/tabs?cacheBuster=${new Date().toISOString()}`
  })
}

export const newAppVersionAvailable = () => {
  return new Promise((resolve, reject) => {
    axios.get('/version.txt', {
      headers: { 'Cache-Control': 'no-cache' }
    }).then((response) => {
      resolve(versionDidChange(getRemoveVersion(response?.data)))
    }).catch((err) => {
      reject(err)
    })
  })
}

const msUntilNextRefresh = () => {
  const now = moment()
  const nextRefresh = now.clone().set({ h: 3, m: 0, s: 0 })
  if (now.isAfter(nextRefresh)) nextRefresh.add(1, 'day')
  return nextRefresh.diff(now)
}

export const morningUpdate = () => {
  setTimeout(() => {
    refreshCache()
  }, msUntilNextRefresh())
}

export const automaticUpdate = () => {
  store.dispatch(setAutomaticUpdate({ automaticallyUpdate: true }))
  setTimeout(() => {
    const state = store.getState()
    const automaticallyUpdate = state?.appState?.automaticallyUpdate
    if (automaticallyUpdate) {
      refreshCache()
    } 
  }, AUTOMATIC_UPDATE_TIMER)
}

export const configureNewAppVersionAvailable = () => {
  let useOnce = true
  setInterval(async () => {
    try {
      const [hasNewVersion, remoteVersion] = await newAppVersionAvailable()
      if (hasNewVersion) {
        const state = store.getState()
        const automaticallyUpdate = state?.appState?.automaticallyUpdate
        store.dispatch(setVersionInfo({ updateAvailable: hasNewVersion, remoteVersion }))
        if (!automaticallyUpdate && useOnce) {
          useOnce = false
          automaticUpdate()
        }
      }
    } catch (err) {
      console.error('error fetching version: check your network connectivity.', err)
    }
  }, INTERVAL_TIMER)
}
